// store/index.js
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

const ls = new SecureLS({ isCompression: false })

const store = createStore({
  state: {
    thisVue: {},
    user: null,
    isAuthenticated: 0,
    email: null,
    emp: null,
    expiryDate: null,
    filterSelected: null,
    syType: null,
    // The role in use: { id, code, level, name } (see NavbarPage.loadMenu).
    activeRole: null,
  },
  getters: {
    getIsAuthenticated: (state) => state.isAuthenticated,
    getEmail: (state) => state.email,
    isExpired: (state) => state.expiryDate < Date.now(),
    getUserData: (state) => state.user,
    getFilterSelected: (state) => state.filterSelected,
    getSyType: (state) => state.syType,
    getEmp: (state) => state.emp,
    activeRole: (state) => state.activeRole,
    activeRoleCode: (state) => state.activeRole?.code ?? null,
    // JHS/SHS for level-limited roles, null when the role covers both.
    activeRoleLevel: (state) => state.activeRole?.level ?? null,
  },
  mutations: {
    SET_ASSIGNED_MODULE(state, moduleID) {
      state.user.user.assignedModuleID = moduleID;
    },
    setExpiryDate(state) {
      const date = new Date()
      date.setDate(date.getDate() + 1)
      state.expiryDate = Date.parse(date)
    },
    setThisVue(state, payload) {
      state.thisVue = payload
    },
    setEmail(state, payload) {
      state.email = payload
    },
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload
    },
    setUserData(state, data) {
      state.user = data
      if (!data) state.activeRole = null
    },
    setActiveRole(state, role) {
      state.activeRole = role
        ? { id: Number(role.id), code: role.code ?? null, level: role.level ?? null, name: role.description }
        : null
    },
    setFilterSelected(state, data) {
      state.filterSelected = data
    },
    setSyType(state, data) {
      state.syType = data
    },
    setEmp(state, data) {
      state.emp = data
    },
  },
  actions: {
    updateAssignedModule({ commit }, moduleID) {
      commit("SET_ASSIGNED_MODULE", moduleID);
    },
    setThisVue({ commit }, payload) {
      commit('setThisVue', payload)
    },
    setEmail({ commit }, payload) {
      commit('setEmail', payload)
    },
    setUser({ commit }, data) {
      commit('setUserData', data)
    },
    setIsAuthenticated({ commit }, data) {
      commit('setIsAuthenticated', data)
    },
    setEmp({ commit }, data) {
      commit('setEmp', data)
    },
  },
  plugins: [
    createPersistedState({
      storage: {
        // A saved value secure-ls can't decode (another app that ran on the
        // same localhost port, or data from an older build) used to throw
        // here and leave a blank page. Drop it and start signed out instead.
        getItem: (key) => {
          try {
            return ls.get(key)
          } catch {
            ls.remove(key)
            return undefined
          }
        },
        setItem: (key, state) => ls.set(key, state),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
})

export default store
